import React from "react";

import { getStatisticsFromOrigin } from "./helpers/requestHandler";
import { Card } from "react-bootstrap";

class StatisticsCard extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        Name: "Loading Data..",
        Value: 0,
        CardType: "overviewcard rounded-4 default",
        Range: global.config.dashboard.range
      };
    }

    async componentDidMount() {
        await this.checkUsers();
    }

    /**
     * Seconds to Hours and Minutes
     * @param {int} seconds - The amount of seconds to convert to hours and minutes.
     * @returns {object} - H: Hours, M: Minutes, S: Seconds
     */

    toHoursAndMinutes(totalSeconds) {
        const totalMinutes = Math.floor(totalSeconds / 60);
      
        const seconds = totalSeconds % 60;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
      
        return { h: hours, m: minutes, s: seconds };
    }

    /**
     * Checks which data to return for the Statistics Card.
     * @param {string} id - The ID Used to determine which statistic to display.
     * @returns {function} sets the state within the constructor for each Statistic card.
     */

    async checkUsers() {
        switch(this.props.data.id) {
            case "activeUsers":
                try {
                    let users = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByCountRange", this.state.Range)
                    this.setState({ 
                        Name: `Sign-Ins (${this.state.Range} Days)`,
                        Value: users,
                        CardType: "overviewcard rounded-4 btop",           
                    })
                } catch (err) {
                   return; 
                }        
                break;
            case "communicatedNotices":
                try {
                    let notices =  await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetCommunicatedNoticesByCountRange", this.state.Range)
                    this.setState({ 
                        Name: `Communicated Notices (${this.state.Range} Days)`,
                        Value: notices,
                        CardType: "overviewcard rounded-4 ptob",
                    })
                } catch (err) {
                   return; 
                }                 
                break;
            case "totalInstances":
                try {
                    let instances = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRange", this.state.Range)
               
                    const uniqueInstancesSet = new Set();
                    instances.forEach(obj => {
                        uniqueInstancesSet.add(obj.instance);
                    });
    
                    this.setState({ 
                        Name: `Total Instances (${this.state.Range} Days)`,
                        Value: Array.from(uniqueInstancesSet).length,
                        CardType: "overviewcard rounded-4 ptor",
                    })  
                } catch (err) {
                    return; 
                }  
                break;
            case "activeBridgeUsers":
                try {
                    let bridgeSignIns = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Bridge/GetActiveUsersByCountBridge", this.state.Range)
                    this.setState({ 
                        Name: `Academy Sign-Ins (${this.state.Range} Days)`,
                        Value: bridgeSignIns,
                        CardType: "overviewcard rounded-4 ptor",
                    })
                } catch (err) {
                    return; 
                }  
                break;
            case "coursesComplete":
                try {
                    let bridgeCoursesComplete = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Bridge/GetCompletedLearnersByCountBridge", this.state.Range, 5000) // Local limit to prevent load times -> need alternative soulution.
                    this.setState({ 
                        Name: `Courses Complete (${this.state.Range} Days)`,
                        Value: bridgeCoursesComplete,
                        CardType: "overviewcard rounded-4 ptob",
                    })
                } catch (err) {
                    return; 
                }  
                break;
                case "activeReachbackUsers":
                    try {
                        let reachbackSignIns = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Reachback/GetActiveUsersByCountReachback", this.state.Range)
                        this.setState({ 
                            Name: `Reachback Sign-Ins (${this.state.Range} Days)`,
                            Value: reachbackSignIns,
                            CardType: "overviewcard rounded-4 ptor",
                        })
                    } catch (err) {
                        return; 
                    }  
                    break;
                    case "activeShopifyUsers":
                        try {
                            let reachbackSignIns = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Shopify/GetActiveUsersByCountShopify", this.state.Range)
                            this.setState({ 
                                Name: `Shopify Sign-Ins (${this.state.Range} Days)`,
                                Value: reachbackSignIns,
                                CardType: "overviewcard rounded-4 ptor",
                            })
                        } catch (err) {
                            return; 
                        }  
                        break;
            default:
                this.setState({ Name: "N/A" })
                this.setState({ CardType: "overviewcard rounded-4 default" })
                console.log("Invalid ID for .card")
        }
    }
  
    render() { 
    if(this.state.Value !== undefined) {
        return (
            <Card className="rounded-4">
                <Card.Body className={this.state.CardType}>
                    <div className="stats">
                        <div><h3>{this.state.Name}</h3></div>
                        <div><h2>{this.state.Value}</h2></div>
                    </div>
                </Card.Body>
            </Card>
        )};
    }
};

export default StatisticsCard;
